import { RSAA } from 'redux-api-middleware'
import { getApiPath } from 'sidecar-utility-library'

import { types, initialState } from './types'

export const fetchBenefitCardInfo = memberUuid => ({
  [RSAA]: {
    endpoint: getApiPath('exp', `members/${memberUuid}/cards`),
    method: 'GET',
    types: [
      types.FETCH_CARD_INFO_REQUEST,
      types.FETCH_CARD_INFO_SUCCESS,
      types.FETCH_CARD_INFO_ERROR,
    ],
  },
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.FETCH_CARD_INFO_REQUEST:
      return {
        ...state,
        benefitCardInfo: {
          ...state.benefitCardInfo,
          busy: true,
          error: null,
        },
      }

    case types.FETCH_CARD_INFO_SUCCESS:
      return {
        ...state,
        benefitCardInfo: {
          ...state.benefitCardInfo,
          busy: false,
          error: null,
          entity: payload,
        },
      }

    case types.FETCH_CARD_INFO_ERROR:
      return {
        ...state,
        benefitCardInfo: {
          ...state.benefitCardInfo,
          busy: false,
          error: 'Error fetching benefit card info',
        },
      }

    default:
      return state
  }
}
